import { FormControl } from "@commonlibs";
import styled, { css } from "styled-components";

export const FileUploadRoot = styled(FormControl)(
    () => css`
        align-self: unset;
        //Full width
        &.full-width {
            width: 100%;
        }
    `,
) as typeof FormControl;
